import { useState } from 'react'
import Welcome from './Welcome.jsx'
import Park from './Park.jsx'
import Exit from './Exit.jsx'
import ContactPage from './ContactPage.jsx'

export default function App() {
  const [started, setStarted] = useState(false)
  const [avatar, setAvatar] = useState(null)
  const [exit, setExit] = useState(false)
  const [contact, setContact] = useState(false)

  if (!started && !exit && !contact) {
    return <Welcome onStart={() => setStarted(true)} onContact={() => setContact(true)} />
  }
  if (started && !exit && !contact) {
  return <Park onExit={() => { setStarted(false); setAvatar(null); setExit(true); setContact(false) }} avatar={avatar} />
  }
  if (exit && !contact) {
    return <Exit navigate={() => { setExit(false); setStarted(false); setAvatar(null); setContact(false) }} onContact={() => setContact(true)} />
  }
  if (contact) {
    return <ContactPage navigate={() => { setContact(false); setExit(false); setStarted(false); setAvatar(null) }} />
  }

  return null
}